import { SPLOOT_BADGE_COLOR } from "../themes";
import { EUnattendedSessionTaskStatus } from "../interfaces";

export enum EOperationTabId {
  UNASSIGNED_SESSIONS = "unassigned-sessions",
  UNATTENDED_SESSIONS = "unattended-sessions",
  INCOMPLETE_SESSIONS = "incomplete-sessions",
  BASE_PAY = "base-pay",
  PENALTIES = "penalties",
  PAYOUT = "payout",
  PAYMENT = "payment",
  KIT_CHECK = "kit-check",
  USER_REFUND = "user-refund",
}

// Shared task status badge colors used across operation tabs
export const TASK_STATUS_BADGE_COLORS = {
  [EUnattendedSessionTaskStatus.PENDING]: SPLOOT_BADGE_COLOR.NEUTRAL,
  [EUnattendedSessionTaskStatus.DONE]: SPLOOT_BADGE_COLOR.GREEN,
} as const;

